import $ from 'jquery';
import tokenInput from './tokenInput';

$(function() {
  var prePopulateData = $('#search-tags').data('searchTags');
  var $tokenInputEl = $('#blog-post-tags');
  $tokenInputEl.tokenInput('/pro/autocomplete?type=tag', {
    prePopulate: prePopulateData,
    allowCreation: false,
    tokenValue: 'name',
    hintText: 'Type in a ticker'
  });

  // Toggle placeholder text
  var $tokenInputListEl = $tokenInputEl.prev();
  var $tokenInputField = $tokenInputListEl.find('input');

  $tokenInputField.on('focus', function() {
    $tokenInputListEl.addClass('active');
  });

  $tokenInputField.on('blur', function() {
    if (!$('.token-input-token').length) {
      $tokenInputListEl.removeClass('active');
    }
  });

  // Hide the placeholder text on search page
  if (window.location.search) {
    $tokenInputListEl.addClass('active');
  }
});
